import { startCase, toLower } from "lodash";
import {
  KursusKorrespondanceField,
  KursusholdPersonKursistField,
  KursusholdUnderviserField,
  PagedKursusQueryField,
} from "../interfaces/kursus";
import { IColumn } from "../interfaces/table";

export const defaultKursusColumns: IColumn<PagedKursusQueryField>[] = [
  {
    field: "fraDato",
    title: "Startdato",
    active: true,
    format: "date",
  },
  {
    field: "tilDato",
    title: "Slutdato",
    active: true,
    format: "date",
  },
  {
    field: "navn",
    title: "Navn",
    active: true,
    format: "string",
  },
  {
    field: "fmukursusKategoriNavigation.navn",
    title: "Kursuskategori",
    active: true,
    format: "string",
  },
  {
    field: "hotelNavigation.navn1",
    title: "Hotel",
    active: true,
    format: "string",
  },

  {
    field: "holdNr",
    title: "Kursusnr.",
    active: true,
    format: "number",
  },

  {
    field: "antalTilmeldteFraLinje",
    title: "Deltagere (fra linje)",
    active: true,
    format: "number",
  },
  {
    field: "antalTilmeldte",
    title: "Deltagere (i alt)",
    active: true,
    format: "number",
  },
  {
    field: "varighed",
    title: "Varighed",
    active: true,
    format: "string",
  },
  {
    field: "kursustypeNavigation.navn",
    title: "Kursustype",
    active: true,
    format: "string",
  },
];

export const defaultKursusholdUnderviserColumns: IColumn<KursusholdUnderviserField>[] =
  [
    {
      field: "person.fuldtNavn",
      title: "Navn",
      active: true,
      format: "string",
      link: (kursusholdUnderviser: any) =>
        `/person/${kursusholdUnderviser.personId}`,
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.firma.navn1",
      title: "Firmanavn1",
      active: true,
      format: "string",
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.emailArbejde",
      title: "E-mail arbejde",
      active: true,
      format: "string",
    },
    {
      field: "person.tlfMobilNr",
      title: "Mobiltelefon",
      active: true,
      format: "string",
    },
    {
      field: "id",
      title: "Id",
      active: false,
      format: "string",
    },
    { field: "opretDato", title: "Oprettet", active: false, format: "date" },
    {
      field: "opretInit",
      title: "Oprettet af",
      active: false,
      format: "string",
    },
  ];

export const defaultKursusholdDeltagereColumns: IColumn<KursusholdPersonKursistField>[] =
  [
    {
      field: "person.kundeNr",
      title: "Kundenr.",
      active: true,
      format: "number",
      link: (fmulinjeKursist: any) => `/person/${fmulinjeKursist.personId}`,
    },
    /*
    {
      field: "person.afsendelsesformStd",
      title: "Afsendelsesform",
      active: true,
      format: "string",
    },
    */
    {
      field: "person.personPersonart.personartNrNavigation.navn",
      title: "Personart",
      active: false,
      format: "string",
    },
    {
      field: "tilmeldDato",
      title: "Tilmeldingsdato",
      active: false,
      format: "date",
    },
    {
      field: "person.fornavne",
      title: "Fornavne",
      active: true,
      format: "string",
    },
    {
      field: "person.efternavn",
      title: "Efternavn",
      active: true,
      format: "string",
    },
    {
      field: "person.fuldtNavn",
      title: "Navn",
      active: false,
      format: "string",
    },
    {
      field: "deltagerStatus",
      title: "Status",
      active: true,
      format: "custom",
      customValue: (rowData) => {
        if (typeof rowData === "string" && rowData !== null) {
          return startCase(rowData.toLocaleLowerCase());
        }
        return "-";
      },
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.firma.navn1",
      title: "Firmanavn",
      active: true,
      format: "string",
    },
    {
      field: "fakturaNr",
      title: "Fakturarnr.",
      active: true,
      format: "string",
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.firma.fakturaAfsendelse",
      title: "Faktura afsend standard",
      active: true,
      format: "custom",
      customValue: (rowData) => {
        if (typeof rowData === "string" && rowData !== null) {
          return startCase(toLower(rowData));
        }
        return rowData as string;
      },
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.emailArbejde",
      title: "E-mail arbejde",
      active: true,
      format: "string",
    },
    {
      field: "person.emailPrivat",
      title: "E-mail privat",
      active: false,
      format: "string",
    },
    {
      field: "person.prioriteretEmail",
      title: "E-mail prioriteret",
      active: true,
      format: "string",
    },
    {
      field: "person.primaerPersonFirmaRelationPaa.firma.tlf",
      title: "Tlf. arbejde",
      active: false,
      format: "string",
    },
    {
      field: "person.tlfMobilNr",
      title: "Mobiltelefon",
      active: false,
      format: "string",
    },
    {
      field: "overnatningstypeNavigation.navn",
      title: "Overnatning",
      active: true,
      format: "string",
    },
    {
      field: "fakturaStatusNavigation.navn",
      title: "Fakturastatus",
      active: true,
      format: "string",
    },
    {
      field: "prisdeltagertotal",
      title: "Total pris",
      active: true,
      format: "number",
    },
    {
      field: "bestaaetMark",
      title: "Har bestået (eksamenskursus)",
      active: false,
      format: "custom",
      customValue: (value) => {
        if (value && typeof value === "string") {
          const titleCase =
            value.charAt(0).toLocaleUpperCase("da-DK") +
            value.slice(1).toLocaleLowerCase("da-DK");
          return titleCase;
        } else {
          return "";
        }
      },
    },
    {
      field: "tilmeldtRaekkefoelge",
      title: "Eksamensnr. (eksamenskursus)",
      active: false,
      format: "string",
    },
    {
      field: "personId",
      title: "PersonID",
      active: false,
      format: "string",
    },
    { field: "opretDato", title: "Oprettet", active: false, format: "date" },
    {
      field: "opretInit",
      title: "Oprettet af",
      active: false,
      format: "string",
    },
  ];

export const defaultKursusKorrespondanceColumns: IColumn<KursusKorrespondanceField>[] =
  [
    {
      field: "sendt",
      title: "Sendt dato",
      active: true,
      format: "date",
    },
    {
      field: "emne",
      title: "Vedr/titel på mail",
      active: true,
      format: "string",
    },
    {
      field: "antalModtagere",
      title: "Antal modtagere",
      active: true,
      format: "number",
    },
    {
      field: "id",
      title: "Id",
      active: false,
      format: "string",
    },
    {
      field: "opretDato",
      title: "Opret dato",
      active: false,
      format: "date",
    },
    {
      field: "opretInit",
      title: "Opret init",
      active: false,
      format: "string",
    },
    {
      field: "retteDato",
      title: "Rette dato",
      active: false,
      format: "date",
    },
    {
      field: "retteInit",
      title: "Rette init",
      active: false,
      format: "string",
    },
  ];
